var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardArrow2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 212,
    viewBox: "0 0 1728 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.43967 -4.03534L-24.9937 -981.033H1752C1747.21 -797.059 1737.15 -48.2971 1735.24 -4.03534C1733.32 40.2264 1675.37 62.9871 1646.63 68.8346C1425.5 112.017 969.836 200.271 916.191 207.827C862.546 215.384 812.413 210.976 794.053 207.827C576.119 166.894 126.362 81.7893 70.8014 68.8346C15.2403 55.88 -1.84309 14.8569 -3.43967 -4.03534Z",
    fill: "#294256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8276 -10C29.5169 4.13895 51.6459 35.6347 126.648 48.506C201.65 61.3773 612.303 136.753 808.255 172.831C823.458 176.732 868.054 182.192 924.812 172.831C981.57 163.47 1402.87 86.0474 1606.42 48.506C1635.98 42.6554 1696.12 22.7634 1700.17 -10",
    stroke: "url(#paint0_linear_220_262)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_262",
    x1: 863.999,
    y1: 177.219,
    x2: 863.999,
    y2: -10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C728F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C728F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrow2);
export default __webpack_public_path__ + "static/media/CardArrow2.00131d42c4c37d506320b7d4f1433671.svg";
export { ForwardRef as ReactComponent };